import type { SetStateAction } from 'react';

import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import resultOzonPrize from '@src/assets/octoberPrizeDraw/resultOzonPrize.png';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';

import { PhoneInput } from './components';
import styles from './styles.module.scss';

const TITLE_TEXT = 'Разыграли 61 сертификат Ozon';
const BADGE_TEXT = 'Результаты розыгрыша';

type Props = {
  setCurrentWinner: React.Dispatch<SetStateAction<Winner | null>>;
  setIsSubmitted: React.Dispatch<SetStateAction<boolean>>;
};

export const OctoberPrizeDrawBanner: React.FC<Props> = ({ setCurrentWinner, setIsSubmitted }) => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <Space direction="vertical" align="center">
        <Badge variant="primary" color="orange" text={BADGE_TEXT} />
        <Heading className={styles.title} level={1}>
          {TITLE_TEXT}
        </Heading>
        <PhoneInput setCurrentWinner={setCurrentWinner} setIsSubmitted={setIsSubmitted} />

        <OptimizedPicture imgClassName={styles.image} img={resultOzonPrize} alt="Ozon" />
      </Space>
    </div>
  </div>
);
